import { cn, Switch } from '@risksmart-app/atomic-ui';
import { Controller, useFormContext } from 'react-hook-form';

export const ExclusiveSwitchGroup = ({
  options,
  disabled,
}: {
  options: { name: string; label: string }[];
  disabled?: boolean;
}) => {
  const { control, setValue } = useFormContext();

  return options.map((option) => (
    <Controller
      key={option.name}
      control={control}
      name={option.name}
      render={({ field }) => (
        <label
          className={cn(
            'flex items-center gap-2 text-sm cursor-pointer select-none',
            disabled && 'opacity-50 cursor-not-allowed'
          )}
          aria-disabled={disabled || undefined}
        >
          {option.label}
          <Switch
            size={'sm'}
            checked={!!field.value}
            disabled={disabled}
            onCheckedChange={(checked) => {
              field.onChange(checked);
              if (checked) {
                options
                  .filter((o) => o.name !== option.name)
                  .forEach((o) =>
                    setValue(o.name, false, { shouldDirty: true })
                  );
              }
            }}
          />
        </label>
      )}
    />
  ));
};
